import React, { useState } from 'react'
import { css } from '@emotion/core'
import { UseFormReturn } from 'react-hook-form'
import { Button } from '@/components/atoms'
import { useTranslation } from 'react-i18next'
import { Editor } from '@/components/organisms/settings/editor'
import { MailDeliveryTag } from '@/components/molecules/settings/mail-delivery/mail-delivery-tag'
import { MailTemplateModal } from './mail-template-modal'
import {
  DeliveryMethod,
  MailDeliveryContent,
  MailDeliveryContentInput,
  TemplateContent,
} from '@/models/mail-delivery/mail-delivery-content'
import { v4 as uuid } from 'uuid'
import { ButtonType } from '@/components/atoms/button'

interface DetailContentFormProps {
  useFormReturn: UseFormReturn<MailDeliveryContentInput>
  detail?: MailDeliveryContent
}

export const FormMailContent: React.FC<DetailContentFormProps> = ({ detail, useFormReturn }) => {
  const [showTemplateModal, setShowTemplateModal] = useState(false)
  const [contentData, setContentData] = useState({
    id: detail?.id || uuid(),
    content: detail?.content.ja || '',
    rawContent: detail?.rawContent.ja || '',
    isLoadTemplate: false,
  })
  const { t } = useTranslation()
  const { register, setValue } = useFormReturn

  const onLoadTemplate = (template: TemplateContent) => {
    setContentData({
      id: uuid(),
      content: template.content.ja,
      rawContent: '',
      isLoadTemplate: true,
    })
    setValue('title', template.title.ja)
    setShowTemplateModal(false)
  }

  return (
    <>
      <div css={inputBlockStyle}>
        <label>{t('mailDelivery.title')}</label>
        <input {...register('title')} style={{ width: 715 }} placeholder={t('Enter subject')} />
        <div className="editor-content input-space">
          <label>{t('mailDelivery.body')}</label>
          <div css={editorBlockStyle}>
            <Editor
              id={contentData?.id}
              placeholder={t('Enter text')}
              htmlContent={contentData?.content}
              rawContent={contentData?.rawContent}
              onChange={(raw: string, html: string) => {
                setValue('content', html, { shouldDirty: true })
                setValue('rawContent', raw, { shouldDirty: true })
              }}
              style={{ height: 567, flex: '0 0 715px' }}
              isShowVideoIcon={false}
              headerElement={
                <Button
                  buttonType={ButtonType.Secondary}
                  fontSize={11}
                  borderRadius={16}
                  width={143}
                  height={27}
                  onClick={() => setShowTemplateModal(true)}
                >
                  {t('Select a template')}
                </Button>
              }
              doFocus={contentData?.isLoadTemplate || false}
            />
            <MailDeliveryTag />
          </div>
        </div>
      </div>
      {showTemplateModal && (
        <MailTemplateModal method={DeliveryMethod.Mail} onSave={onLoadTemplate} onClose={() => setShowTemplateModal(false)} />
      )}
    </>
  )
}

const inputBlockStyle = css({
  padding: '25px 32px 0 32px',
  label: {
    display: 'block',
    marginBottom: 12,
    fontSize: 12,
    fontWeight: 'bold',
  },
  input: {
    height: 32,
    padding: '8px 16px',
    border: '1px solid #CCCCCC',
    borderRadius: 17,
    textAlign: 'left',
    '::placeholder': {
      color: '#CCCCCC',
    },
  },
  '.input-space': { marginTop: 24 },
})

const editorBlockStyle = css({
  display: 'flex',
  alignItems: 'flex-start',
  width: '100%',
  gap: 16,
})
